import { createGtag } from 'vue-gtag';
import router from '../router';

const gtag = createGtag({
    initMode: 'manual',
    tagId: import.meta.env.VITE_APP_G_ANALYTICS_ID,
    pageTracker: {
        router,
        useScreenview: true,
    },
    appName: import.meta.env.VITE_APP_NAME,
    linker: {
        domains: ['betbra.bet.br', 'bolsadeaposta.bet.br', 'fulltbet.bet.br', 'oddjusta.com', 'matchbook.bet.br'],
        accept_incoming: true,
    },
});

export default gtag;
